{
    "May the force be with you": "May the force be with you",
    "Digit1": "1",
    "Digit2": "2",
    "Digit3": "3",
    "Digit4": "4",
    "Digit5": "5",
    "Digit6": "6",
    "Digit7": "7",
    "Digit8": "8",
    "Digit9": "9",
    "Digit0": "0",
    "KeyA": "A",
    "KeyB": "B",
    "KeyC": "C",
    "KeyD": "D",
    "KeyE": "E",
    "KeyF": "F",
    "KeyG": "G",
    "KeyH": "H",
    "KeyI": "I",
    "KeyJ": "J",
    "KeyK": "K",
    "KeyL": "L",
    "KeyM": "M",
    "KeyN": "N",
    "KeyO": "O",
    "KeyP": "P",
    "KeyQ": "Q",
    "KeyR": "R",
    "KeyS": "S",
    "KeyT": "T",
    "KeyU": "U",
    "KeyV": "V",
    "KeyW": "W",
    "KeyX": "X",
    "KeyY": "Y",
    "KeyZ": "Z",
    "Comma": ",",
    "Period": ".",
    "Semicolon": ";",
    "Quote": "'",
    "BracketLeft": "[",
    "BracketRight": "]",
    "Backquote": "`",
    "Backslash": "\\",
    "Minus": "-",
    "Equal": "=",
    "AltLeft": "Alt",
    "AltRight": "Alt",
    "CapsLock": "CapsLock",
    "ControlLeft": "ControlLeft",
    "ControlRight": "ControlRight",
    "OSLeft": "OSLeft",
    "OSRight": "OSRight",
    "ShiftLeft": "ShiftLeft",
    "ShiftRight": "ShiftRight",
    "ContextMenu": "ContextMenu",
    "Enter": "Enter",
    "Space": "Space",
    "Tab": "Tab",
    "Delete": "Delete",
    "End": "End",
    "Help": "Help",
    "Home": "Home",
    "Insert": "Insert",
    "PageDown": "PageDown",
    "PageUp": "PageUp",
    "ArrowDown": "ArrowDown",
    "ArrowLeft": "ArrowLeft",
    "ArrowRight": "ArrowRight",
    "ArrowUp": "ArrowUp",
    "Escape": "Escape",
    "PrintScreen": "PrintScreen",
    "ScrollLock": "ScrollLock",
    "Pause": "Pause",
    "Put the videos side by side": "Placer les vidéos côte à côte",
    "Minimize video": "Minimiser la vidéo",
    "Close video": "Fermer la vidéo",
    "Place the video on the other side of the screen": "Placer la vidéo de l'autre côté de l'écran",
    "Maximize video": "Maximiser la vidéo",
    "Swap position of the videos": "Échanger les positions des vidéos",
    "loadManifest(): Invalid current player state: $1": "loadManifest() : Statut de lecture actuel invalide : $1",
    "loadPlayer(): Invalid current player state: $1": "loadPlayer() : Statut de lecture actuel invalide : $1",
    "Could not load player: state transition in progress: $1": "Impossible de charger le lecteur : transition d’état en cours : $1",
    "Could not unload player: state transition in progress: $1": "Impossible de supprimer le lecteur : transition d’état en cours : $1",
    "unloadManifest(): Invalid current player state: $1": "unloadManifest() : Statut de lecteur actuellement invalide : $1",
    "Error loading video manifest: $1 $2": "Erreur lors du chargement des informations vidéo : $1 $2",
    "Play/pause": "Lecture/Pause",
    "Select the active audio track": "Sélectionner la piste audio active",
    "Toggle audio mute": "Activer/désactiver le mode muet",
    "Toggle play/pause": "Basculer Lecture/Pause",
    "Toggle captions": "Activer/désactiver les sous-titres",
    "Backward $1 seconds": "Reculer de $1 secondes",
    "Forward $1 seconds": "Avancer de $1 secondes",
    "Volume up 10%": "Augmenter le volume de 10 %",
    "Volume down 10%": "Diminuer le volume de 10 %",
    "Close pop-up": "Fermer la fenêtre contextuelle",
    "Decrease playback speed": "Réduire la vitesse de lecture",
    "Increase playback speed": "Augmenter la vitesse de lecture",
    "Swap between side by side and minimized video": "Basculer entre vidéos côte à côte et vidéo minimisée",
    "Swap the position of the videos": "Échanger les positions des vidéos",
    "Dual stream 50%": "Dual stream 50%",
    "Two videos 50%": "Deux vidéos 50%",
    "Play": "Lecture",
    "Play/Pause button": "Bouton Lecture/Pause",
    "Starts and stops video playback. When the video reaches the end, this button also allows you to restart playback from the beginning.": "D\u00e9marre et arr\u00eate la lecture de la vid\u00e9o. Lorsque la vid\u00e9o atteint la fin, ce bouton permet \u00e9galement de recommencer la lecture depuis le d\u00e9but.",
    "Toolbar": "Barre d'outils",
    "Left-side buttons": "Boutons \u00e0 gauche",
    "Right-side buttons": "Boutons \u00e0 droite",
    "Back": "Retour",
    "playPauseButtonHelp.title": "Aide du bouton Lecture/Pause",
    "playPauseButtonHelp.description": "Ce bouton vous permet de lire ou de mettre en pause la vid\u00e9o.",
    "Options": "Options",
    "Configuration options": "Options de configuration",
    "Settings": "Ajustements",
    "Settings options": "Options d'ajustement"
}
